var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var d, c = arguments.length, r = c < 3 ? target : null === desc ? desc = Object.getOwnPropertyDescriptor(target, key) : desc;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(decorators, target, key, desc); else for (var i = decorators.length - 1; i >= 0; i--) (d = decorators[i]) && (r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r);
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}, __metadata = this && this.__metadata || function(k, v) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(k, v);
}, __param = this && this.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};

import { inject, injectable, named } from "../../../common/inversify-lite";

import { getTheme } from "../../../graphic/theme";

import { CIRCLE_NUMBER_TYPE } from "../../../graphic/constants";

import { CircleRenderContribution } from "./contributions/constants";

import { ContributionProvider } from "../../../common/contribution-provider";

import { BaseRender } from "./base-render";

import { defaultCircleBackgroundRenderContribution, defaultCircleRenderContribution, defaultCircleTextureRenderContribution } from "./contributions";

let DefaultCanvasCircleRender = class extends BaseRender {
    constructor(circleRenderContribitions) {
        super(), this.circleRenderContribitions = circleRenderContribitions, this.numberType = CIRCLE_NUMBER_TYPE, 
        this.builtinContributions = [ defaultCircleRenderContribution, defaultCircleBackgroundRenderContribution, defaultCircleTextureRenderContribution ], 
        this.init(circleRenderContribitions);
    }
    drawShape(circle, context, x, y, drawContext, params, fillCb, strokeCb) {
        const circleAttribute = getTheme(circle, null == params ? void 0 : params.theme).circle, {radius: radius = circleAttribute.radius, startAngle: startAngle = circleAttribute.startAngle, endAngle: endAngle = circleAttribute.endAngle, x: originX = circleAttribute.x, y: originY = circleAttribute.y} = circle.attribute, data = this.valid(circle, circleAttribute, fillCb, strokeCb);
        if (!data) return;
        const {fVisible: fVisible, sVisible: sVisible, doFill: doFill, doStroke: doStroke} = data;
        context.beginPath(), context.arc(x, y, radius, startAngle, endAngle), context.closePath(), 
        context.setShadowBlendStyle && context.setShadowBlendStyle(circle, circle.attribute, circleAttribute), 
        this.beforeRenderStep(circle, context, x, y, doFill, doStroke, fVisible, sVisible, circleAttribute, drawContext, fillCb, strokeCb), 
        doFill && (fillCb ? fillCb(context, circle.attribute, circleAttribute) : fVisible && (context.setCommonStyle(circle, circle.attribute, originX - x, originY - y, circleAttribute), 
        context.fill())), doStroke && (strokeCb ? strokeCb(context, circle.attribute, circleAttribute) : sVisible && (context.setStrokeStyle(circle, circle.attribute, originX - x, originY - y, circleAttribute), 
        context.stroke())), this.afterRenderStep(circle, context, x, y, doFill, doStroke, fVisible, sVisible, circleAttribute, drawContext, fillCb, strokeCb);
    }
    draw(circle, renderService, drawContext, params) {
        const circleAttribute = getTheme(circle, null == params ? void 0 : params.theme).circle;
        this._draw(circle, circleAttribute, !1, drawContext, params);
    }
};

DefaultCanvasCircleRender = __decorate([ injectable(), __param(0, inject(ContributionProvider)), __param(0, named(CircleRenderContribution)), __metadata("design:paramtypes", [ Object ]) ], DefaultCanvasCircleRender);

export { DefaultCanvasCircleRender };
//# sourceMappingURL=circle-render.js.map
